import * as React from "react";
import type { IMegaMenuBloc } from "./definitions";
import { DynLabel, AppLabel } from "@@services/i18nservice";
import {
    MegaMenuFavoriteButton,
    MegaMenuFavoriteButtonIsFavClassName,
    MegaMenuFavoriteButtonIsNotFavClassName,
    MegaMenuPanelItem
} from "./megamenupanel.item";
import type { IMegaMenuPanelSectionProps } from "./megamenupanel.section";

export interface IMegaMenuPanelBlocProps extends IMegaMenuPanelSectionProps {
    bloc: IMegaMenuBloc;
}

export interface IMegaMenuPanelBlocState {

}

export class MegaMenuPanelBloc extends React.Component<IMegaMenuPanelBlocProps, IMegaMenuPanelBlocState> {
    render() {
        let content = null;
        let addFav;
        let allFav = true;
        if (this.props.bloc.component) {
            content = React.createElement(this.props.bloc.component, this.props);
        } else {
            addFav = true;
            content = <ul>
                {this.props.bloc.items.map((it, idx) => {
                    allFav = allFav && it.favorite;
                    return <li key={it.key || "bloc" + idx}>
                        <MegaMenuPanelItem key={it.key || "bloc" + idx} {...this.props} item={it} />
                    </li>;
                })}
            </ul>;
        }
        let title;
        if (this.props.bloc.label || this.props.bloc.title) {
            const innerTitle = this.props.bloc.label
                ? <DynLabel i18n={this.props.bloc.label} />
                : <AppLabel i18n={this.props.bloc.title} />;
            const toggleFavorite = addFav && <MegaMenuFavoriteButton {...this.props} isFav={allFav} toggleFavorite={() => {
                const favs = this.props.bloc.items.filter((i) => allFav || !i.favorite).map((i) => ({ 
                    key: i.key, 
                    menuKey: this.props.entry.key 
                }));
                
                this.props.onToggleFavorites(favs);
            }} />;
            const classes = ["bloc-title",
                allFav ? MegaMenuFavoriteButtonIsFavClassName : MegaMenuFavoriteButtonIsNotFavClassName];
            // title = this.props.bloc.showAsSection
            //     ? <h3 className={classes.join(' ')}>{innerTitle}{toggleFavorite}</h3>
            //     : <h4 className={classes.join(' ')}>{innerTitle}{toggleFavorite}</h4>;
            title = React.createElement(this.props.bloc.showAsSection ? "h3" : "h4",
                { className: classes.join(' ') }, <>{innerTitle}{toggleFavorite}</>);

        }
        return <div className="megamenu-panel-bloc">
            {title}
            <div className="megamenu-panel-bloc-items">
                {content}
            </div>
        </div>;
    }
}
